import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import SignoutHeader from "../subcomponents/SignoutHeader";
import { Colors } from "../Colors";
import axios from "axios";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import { NotificationItem } from "../types";

const NotificationsPage: React.FC = () => {
  const [notifications, setNotifications] = React.useState<NotificationItem[]>([]);

  const user = useSelector((state: RootState) => state.auth.user);

  React.useEffect(() => {
    const fetchNotifications = async () => {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/notifications`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      });
      console.log(response.data);
      // sort the payers
      setNotifications(response.data);
    };
    if (user?.token) {
      fetchNotifications();
    }
  }, [user?.token]);

  return (
    <Box>
      {/* payers table with id and name columns */}
      <SignoutHeader />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginTop: 2,
        }}
      >
        <h1>Notifications</h1>
        <Box
          sx={{
            width: "100%",
            maxWidth: 800,
            bgcolor: Colors.bg,
            borderRadius: 2,
            boxShadow: 1,
            overflow: "auto",
          }}
        >
          {notifications.map((notification, index) => (
            <Box
              key={index}
              sx={{
                padding: 2,
                borderBottom: "1px solid #ccc",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span>{notification.message}</span>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default NotificationsPage;
